import { useRouter } from "@tanstack/react-router";
import { ChevronLeftIcon } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/button";
import { SearchField, SearchInput } from "@/components/search-field";
import { usePageTitle } from "@/hooks/usePageTitle";

import { TablePaginationFooter } from "../../components/TablePaginationFooter";
import { CreditsTable } from "./components/CreditsTable";
import { useCredits } from "./hooks/useCredits";

const DEFAULT_LIMIT = 10;

export function CreditsPage() {
  const { history } = useRouter();
  const { data: credits = [] } = useCredits();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(DEFAULT_LIMIT);

  usePageTitle("Credits");

  return (
    <div className="bg-bg-tertiary sm:p-xl">
      <div className="flex flex-col bg-bg-primary sm:rounded-xl">
        <div className="flex items-center gap-2xl border-b border-b-border-secondary px-xl pt-xl pb-xl sm:px-2xl">
          <Button
            className="shrink-0"
            color="gray"
            isIconOnly
            onPress={() => history.go(-1)}
            size="lg"
            variant="secondary"
          >
            <ChevronLeftIcon aria-label="Back" size={20} />
          </Button>
          <h1 className="text-2xl font-semibold text-text-primary">Credits</h1>
        </div>

        <div className="p-xl">
          <SearchField
            aria-label="Search credits"
            onChange={setSearch}
            value={search}
          >
            <SearchInput
              onClear={() => setSearch("")}
              placeholder="Search..."
            />
          </SearchField>
        </div>

        <CreditsTable credits={credits} />

        <TablePaginationFooter
          limit={limit}
          onLimitChange={setLimit}
          onPageChange={setPage}
          page={page}
          pageSizeLabel="Credits per page"
          totalPages={Math.max(1, Math.ceil(credits.length / limit))}
        />
      </div>
    </div>
  );
}
